import domainFn from '@/apis/defence';
export const newWebSocket: any = {
  websocket: null,
  heartbeat_timer: null, // 用于心跳检测
  active_close: false, // 是否主动关闭
  times: 0,
  init: (params: any) => {
    console.log(params, 333);
    newWebSocket.websocket = new WebSocket(params.url, [params.token]);
    newWebSocket.websocket.onopen = (data: any) => {
      newWebSocket.heartbeat();
      if (params.onopen) {
        params.onopen('webSocket已连接', data);
        newWebSocket.times = 0;
      }
    };
    newWebSocket.websocket.onmessage = (data: any) => {
      if (params.onmessage) {
        params.onmessage(data.data);
      }
    };
    newWebSocket.websocket.onclose = () => {
      clearInterval(newWebSocket.heartbeat_timer);
      if (newWebSocket.active_close) {
        if (params.onclose) {
          params.onclose('连接已手动关闭');
        }
      } else {
        newWebSocket.reconnect(params);
        if (params.onclose) {
          params.onclose('连接已关闭, 正在重连');
        }
      }
    };
    newWebSocket.websocket.onerror = (error: any) => {
      newWebSocket.times += 1;
      if (newWebSocket.times > 10) {
        newWebSocket.times = 0;
        domainFn.logWSError(error);
      }
      clearInterval(newWebSocket.heartbeat_timer);
      if (params.onerror) {
        params.message('连接发生错误！等待五秒后重连');
        setTimeout(() => {
          newWebSocket.reconnect(params);
        }, 5000);
      }
    };
  },
  heartbeat: () => {
    console.log('执行心跳');
    if (newWebSocket.heartbeat_timer) {
      clearInterval(newWebSocket.heartbeat_timer);
    }
    newWebSocket.heartbeat_timer = setInterval(function () {
      newWebSocket.websocket.send('heartbeatPc');
    }, 50000);
  },
  reconnect: (params: any) => {
    console.log('执行重连');
    newWebSocket.active_close = false;
    if (newWebSocket.websocket) {
      newWebSocket.websocket.close();
    }
    newWebSocket.init(params);
  },
  close: () => {
    console.log('手动关闭，无需重连');
    clearInterval(newWebSocket.heartbeat_timer);
    newWebSocket.active_close = true;
    newWebSocket.websocket.close();
  }
};

// old
// const linkWebsocket = (url: string, msg?: string) => {
//   const websocket = new WebSocket(url, [authInfo.token]);
//   setWebsocketFn(websocket);
//   // 引入websocket
//   websocket.onopen = function () {
//     console.log('websocket open');
//   };
//   // 结束websocket
//   websocket.onclose = function () {
//     console.log('websocket close');
//     if (modelShow) {
//       if (linkNum >= 5) {
//         console.log(' 重新连接次数大于5次, 取消重新连接');
//         return false;
//       }
//       console.log('意外结束会话, 重新连接');
//       steLinkNum(linkNum + 1);
//       getWebsocketUrls();
//     }
//   };
//   // 接受到信息
//   websocket.onmessage = function (e) {
//     console.log(e.data);
//     getMessage(e.data);
//   };
//   setTimeout(() => {
//     websocket.send('msg');
//   }, 1500);
// };
